import { Grid, GridProps } from "@mui/material";
import React from "react";
interface MxFormLayoutProps extends GridProps {
  children: React.ReactNode;
}
const MxFormLayoutMain = (props: MxFormLayoutProps) => {
  return (
    <Grid
      container
      item
      xs={12}
      py={{
        xs: 0,
        md: 2
      }}
      px={{
        xs: 0,
        md: 1.5
      }}
      id="mx-form-layout-main"
    >
      <Grid
        item
        xs={12}
        {...props}
        borderRadius={{
          xs: 0,
          md: 2
        }}
      >
        {props.children}
      </Grid>
    </Grid>
  );
};

export default MxFormLayoutMain;
